export default "__VITE_ASSET__glHTJmy5__"